// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3gU0h","header":"PatientQuestionnaire_header__1KwEb","info":"PatientQuestionnaire_info__Z8sXs"};